"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionParams = void 0;
const utils_1 = require("../utils");
const Payhere_1 = require("../Payhere");
class SubscriptionParams {
    constructor(subscriptionParams) {
        this._subscriptionParams = subscriptionParams;
    }
    toJSON() {
        const formattedItems = this._subscriptionParams.items
            ? this._subscriptionParams.items.map((item, index) => ({
                [`item_name_${index}`]: item.name,
                [`item_number_${index}`]: item.modelNo,
                [`amount_${index}`]: item.amount,
                [`quantity_${index}`]: item.quantity,
            }))
            : [];
        const jsonObj = {
            merchant_id: Payhere_1.Payhere.merchantId,
            return_url: this._subscriptionParams.returnUrl,
            cancel_url: this._subscriptionParams.cancelUrl,
            notify_url: this._subscriptionParams.notifyUrl,
            order_id: this._subscriptionParams.order_id,
            items: this._subscriptionParams.itemTitle,
            currency: this._subscriptionParams.currency,
            amount: this._subscriptionParams.amount,
            recurrence: this._subscriptionParams.recurrence.toString(),
            duration: this._subscriptionParams.duration.toString(),
            ...formattedItems,
            platform: this._subscriptionParams.platform,
            custom_1: this._subscriptionParams.custom1,
            custom_2: this._subscriptionParams.custom2,
            hash: this._subscriptionParams.hash,
        };
        return (0, utils_1.removeBlankAttributes)(jsonObj);
    }
}
exports.SubscriptionParams = SubscriptionParams;
